import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as logAgent } from "../../redux/agent";
import { mapActionsToProps } from "../../redux/report/agent";
class AgentLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          gte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD startDayNoSec"),
          lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD endDayNoSec"),
        },
        page: 0,
        pageSize: 20,
      },
      listAgents: [],
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    this.itemInit();
    this.props.getListAgent(null, null, null, null, null, { query: "all" });
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "agentId":
            case "statusId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key === "gte") {
                  and.push({
                    createdAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    createdAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getLogAgent(filters.order, {
      where,
    });
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    const where = {};
    const and = [];
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "statusId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key === "gte") {
                  and.push({
                    createdAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    createdAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    if (this.state.selectedAgent) {
      filters.where["agentId"] = this.state.selectedAgent;
      this.props.getLogAgent(filters.order, {
        where: {
          and: [
            { createdAt: { gte: filters.where.gte } },
            { createdAt: { lte: filters.where.lte } },
          ],
          agentId: filters.where["agentId"],
          statusId: filters.where.statusId,
        },
      });
    } else {
      delete filters.where["agentId"];
      this.props.getLogAgent(filters.order, {
        where: {
          and: [
            { createdAt: { gte: filters.where.gte } },
            { createdAt: { lte: filters.where.lte } },
          ],
          statusId: filters.where.statusId,
        },
      });
    }
    this.props.getLogAgent(filters.order, {
      where,
    });
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(
      gte,
      "YYYY-MM-DD startDayNoSec"
    );
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD endDayNoSec");
    this.setState({ lte });
  };

  _export;
  export = () => {
    this._export.save();
  };
  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              (item &&
                item.code &&
                item.code.toLowerCase().includes(search.toLowerCase())) ||
              (item &&
                item.user &&
                item.user.fullname &&
                item.user.fullname.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  handleSearchUser = (text) => {
    const { listAgents } = this.props;
    this.setState({
      listAgents: this.filterCustomers(_.values(listAgents), text),
    });
  };

  render() {
    const { classes, logAgent, listAgents } = this.props;
    const { filters } = this.state;
    const listAgentLog =
      typeof logAgent === "object"
        ? Object.keys(logAgent).map((key) => logAgent[key])
        : logAgent;
    const listAgentsResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    const listAgentLogExcel = JSON.parse(JSON.stringify(listAgentLog)).map(
      (item) => {
        return {
          code: item.agent ? (item.agent.code ? item.agent.code : "") : "",
          account: item.user ? item.user.username : "",
          name: item.user ? item.user.fullname : "",
          status: item?.status?.name || "",
          createdAt: item.createdAt
            ? datetimeHelper.toFormat(item.createdAt, "YYYY-MM-DD HH:mm:ss")
            : 0,
          endAt: item.endAt
            ? datetimeHelper.toFormat(item.endAt, "YYYY-MM-DD HH:mm:ss")
            : 0,
        };
      }
    );

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={4}>
                        <SelectAutoComplete
                          label={"Mã điện thoại viên"}
                          data={
                            this.state.listAgents &&
                            this.state.listAgents.length > 0
                              ? this.state.listAgents.map((val) => {
                                  return {
                                    id: val.id,
                                    label: val.user
                                      ? `${val.code} - ${val.user.fullname}`
                                      : "",
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchUser(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState(
                              {
                                selectedAgent: item ? item.id : "",
                              },
                              () => {
                                this.handleSubmit();
                              }
                            );
                          }}
                          className={classes.input}
                          onClear={true}
                          name="agentId"
                        />
                      </Grid>
                      <Grid item md={4}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Trạng thái"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.statusId}
                          name="statusId">
                          <MenuItem>Tất cả</MenuItem>
                          {_.values(this.props.agentStatus).length
                            ? _.values(this.props.agentStatus).map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              ))
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          maxDate={new Date()}
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="yyyy/MM/dd HH:mm"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid
                        item
                        md={3}
                        style={{ alignItem: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.export}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                        <ExcelExport
                          data={listAgentLogExcel}
                          ref={(exporter) => (this._export = exporter)}
                          fileName="Lịch sử làm việc của điện thoại viên.xlsx">
                          <ExcelExportColumn
                            field="code"
                            title="Mã điện thoại viên"
                            locked={true}
                            width={120}
                          />
                          <ExcelExportColumn
                            field="account"
                            title="Tài khoản"
                            width={160}
                          />
                          <ExcelExportColumn
                            field="name"
                            title="Tên điện thoại viên"
                            width={160}
                          />
                          <ExcelExportColumn
                            field="status"
                            title="Trạng thái"
                            width={90}
                          />
                          <ExcelExportColumn
                            field="createdAt"
                            title="Thời gian bắt đầu"
                            width={150}
                          />
                          <ExcelExportColumn
                            field="endAt"
                            title="Thời gian kết thúc"
                            width={150}
                          />
                          <ExcelExportColumn
                            field="note"
                            title="Ghi chú"
                            width={150}
                          />
                        </ExcelExport>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Mã điện thoại viên
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tài khoản
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tên điện thoại viên
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Trạng thái
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Thời gian bắt đầu
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Thời gian kết thúc
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Ghi chú
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listAgentLog !== 0
                ? listAgentLog.map((row, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.agent
                            ? row.agent.code
                              ? row.agent.code
                              : ""
                            : ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row?.user?.username || ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row?.user?.fullname || ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row?.status?.name || ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.createdAt
                            ? datetimeHelper.toFormat(
                                row.createdAt,
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.endAt
                            ? datetimeHelper.toFormat(
                                row.endAt,
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.note || ""}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loadingInfo} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  fab: {
    marginRight: 10,
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
});

AgentLog.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  logAgent: state.agent.logAgent,
  loadingInfo: state.agent.loadingInfo,
  listAgents: state.agent.agents,
  agentStatus: state.agentStatus.agentStatus,
});

const LogAgent = connect(null, logAgent)(AgentLog);
AgentLog = connect(mapStateToProps, mapActionsToProps)(LogAgent);
export default withStyles(styles)(AgentLog);
